export default __webpack_public_path__ + "static/media/relative-medium-pro.9444d5b0.ttf";